// extracted by mini-css-extract-plugin
export default {"formContainer":"AppForm_formContainer__K+fvI","error":"AppForm_error__9hUh0"};